import radium from 'radium';
import {
	FacebookIcon,
	FacebookShareButton, TwitterIcon,
	TwitterShareButton, WhatsappIcon,
	WhatsappShareButton,
} from 'react-share';


function SocialNetworks(props) {
	const style = {
		display: 'flex',
		justifyContent: 'space-between',
		margin: '2em 1em 0',
		flexGrow: '1',
		alignItems: 'flex-end',
		'@media (min-width : 768px)': {
			justifyContent: 'space-around',
			width: '50%',
			margin: '2em auto 5em',
		},
	};

	const shareUrl = props.shareUrl;
	const shareTitle = props.shareTitle;

	return (
		<div style={style}>
			<FacebookShareButton
				url={shareUrl}
				title={shareTitle}
			>
				<FacebookIcon
					size={30}
					round
				/>
			</FacebookShareButton>
			<WhatsappShareButton
				url={shareUrl}
				title={shareTitle}
				separator=" "
			>
				<WhatsappIcon
					size={30}
					round
				/>
			</WhatsappShareButton>
			<TwitterShareButton
				url={shareUrl}
				title={shareTitle}
			>
				<TwitterIcon
					size={30}
					round
				/>
			</TwitterShareButton>
		</div>
	);
}

export default radium(SocialNetworks);
